<template>
  <div class="attendance-item">
    <attendanceList
      :attendanceList="attendanceList"
      class="attendance-list-content-main"
      v-bitmap="getListResult"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import attendanceList from "../attendance-list/attendance-list.vue";
export default {
  props: {
    attendanceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pageSize: {
      type: Number,
    },
    total: {
      type: Number,
    },
    getListResult: {
      type: String,
    },
  },
  components: {
    attendanceList,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    currentPageNumChange(e) {
      this.$emit("currentPageNumChange", e);
    },
    handleSizeChange(e) {
      this.$emit("handleSizeChange", e);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./attendance-item.scss";
</style>